<mat-card appearance="outlined" id="temp-pwd-card">
  <mat-toolbar> <span>Change Temporary Password</span> </mat-toolbar>
  @if (formSubmitted) {
    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>
  }
  @if ((tempPwdShowError$ | async)) {
    <mat-toolbar
      id="temp-pwd-banner"
      color="warn"
      fxFlexFill
      >
      <span id="temp-pwd-banner-message">
        Temporary password does not match. Please verify temporary password
        is correct then try again.
      </span>
    </mat-toolbar>
  }
  <mat-card-content>
    <div id="temp-pwd-container">
      <p>
        A temporary password was used to log in. To use Passport, please
        set your new password immediately.
      </p>
      <form
        novalidate
        id="temp-pwd-form"
        (ngSubmit)="submit()"
        [formGroup]="tempPwdForm"
        >
        <div
          formGroupName="passwordGroup"
          id="temp-pwd-form-password-group"
          flex-wrap="wrap"
          fxLayout="row wrap"
          fxLayoutAlign="start center"
          >
          <mat-form-field>
            <input
              matInput
              id="temp-pwd-form-old-password"
              [type]="hide1 ? 'password' : 'text'"
              placeholder="Temporary Password"
              formControlName="password"
              required
              />
            <mat-icon
              id="temp-pwd-form-temp-pwd-icon"
              class="reset-pwd-icon"
              matSuffix
              fontSet="fa"
              fontIcon="{{ hide1 ? 'fa-eye-slash' : 'fa-eye' }}"
              (click)="hide1 = !hide1"
              (keyup)="markAsTouched($event)"
              >
            </mat-icon>
            @if (
              tempPwdForm
              .get('passwordGroup.password')
              ?.hasError('required') &&
              tempPwdForm.get('passwordGroup.password')
              ?.touched
              ) {
              <mat-error
                >
                Temporary password is required
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <input
              matInput
              id="temp-pwd-form-password"
              [type]="hide2 ? 'password' : 'text'"
              placeholder="Password"
              formControlName="newPassword"
              required
              />
            <mat-icon
              id="temp-pwd-form-new-pwd-icon"
              class="reset-pwd-icon"
              matSuffix
              fontSet="fa"
              fontIcon="{{ hide2 ? 'fa-eye-slash' : 'fa-eye' }}"
              (click)="hide2 = !hide2"
              (keyup)="markAsTouched($event)"
              >
            </mat-icon>
            @if (
              tempPwdForm
              .get('passwordGroup.newPassword')
              ?.hasError('required') &&
              tempPwdForm.get('passwordGroup.newPassword')
              ?.touched
              ) {
              <mat-error
                >
                Password is required
              </mat-error>
            }
            @if (
              tempPwdForm
              .get('passwordGroup.newPassword')
              ?.hasError('pwdLength') &&
              tempPwdForm.get('passwordGroup.newPassword')
              ?.touched
              ) {
              <mat-error
                >
                New password must be between 8-256 characters
              </mat-error>
            }
            @if (
              tempPwdForm
              .get('passwordGroup.newPassword')
              ?.hasError('newPassword') &&
              tempPwdForm.get('passwordGroup.newPassword')
              ?.touched
              ) {
              <mat-error
                >
                New password cannot be the same as the temporary
                password
              </mat-error>
            }
          </mat-form-field>
          <mat-chip-listbox style="padding: 10px 0 10px 0">
            <mat-chip-option
              color="{{ chipColor('pwdLength') }}"
              selected="true"
              >8-256 Characters</mat-chip-option
              >
            </mat-chip-listbox>
            <mat-form-field>
              <input
                matInput
                id="temp-pwd-form-confirm-password"
                [type]="hide3 ? 'password' : 'text'"
                placeholder="Confirm Password"
                formControlName="confirmPassword"
                required
                />
              <mat-icon
                id="temp-pwd-form-confirm-pwd-icon"
                class="reset-pwd-icon"
                matSuffix
                fontSet="fa"
                fontIcon="{{ hide3 ? 'fa-eye-slash' : 'fa-eye' }}"
                (click)="hide3 = !hide3"
                (keyup)="markAsTouched($event)"
                >
              </mat-icon>
              @if (
                tempPwdForm
                .get('passwordGroup.confirmPassword')
                ?.hasError('required') &&
                tempPwdForm.get('passwordGroup.confirmPassword')
                ?.touched
                ) {
                <mat-error
                  >
                  Confirm password is required
                </mat-error>
              }
              @if (
                tempPwdForm
                .get('passwordGroup.confirmPassword')
                ?.hasError('matchPassword') &&
                tempPwdForm.get('passwordGroup.confirmPassword')
                ?.touched
                ) {
                <mat-error
                  >
                  Confirm password does not match Password field
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div
            id="form-buttons"
            fxLayout="row"
            fxLayoutWrap
            fxLayoutAlign="end"
            >
            <button
              id="form-back-button"
              class="back-button support-buttons"
              mat-raised-button
              (click)="goBack()"
              type="button"
              color="secondary"
              >
              Cancel
            </button>
            <button
              id="submit-button"
              class="support-buttons"
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="tempPwdForm.untouched || !tempPwdForm.valid"
              >
              Update Password
            </button>
          </div>
        </form>
      </div>
    </mat-card-content>
  </mat-card>
